module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<footer class="footer bar-light">\n    <div class="container form-inline">\n        <p class="text-muted form-group col-md-3">© Review & Sign 2017</p>\n        <p class="text-muted form-group col-md-4">\n            Main Phone Number: 833-2ASKRNS (833-227-5767)\n            Main Fax Number: 833-2FAXRNS (833-232-9767)\n        </p>\n        <div class="text-muted form-group col-md-3 pull-right">\n            <a class="pull-right" href="/#help">Help</a>\n        </div>\n    </div>\n</footer>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/layout/footer.html
// module id = 529
// module chunks = 0